export const categoryList = [
  {
    name: 'کابل شبکه',
    image: '/images/categories/network-cable-min.png',
    url: '/cat/passive-equipment/network-cable/',
  },
  {
    name: 'کابل فیبرنوری',
    image: '/images/categories/fiberoptic-cable-min.png',
    url: '/cat/fiberoptic-equipment/fiber-optic-cable/',
  },
  {
    name: 'رک',
    image: '/images/categories/rack-min.png',
    url: '/cat/passive-equipment/network-rack/',
  },
  {
    name: 'پج پنل',
    image: '/images/categories/patch-panel-min.png',
    url: '/cat/passive-equipment/network-connections/patch-panel/',
  },
  {
    name: 'اتصالات شبکه',
    image: '/images/categories/etesalat-min.png',
    url: '/cat/passive-equipment/network-connections/',
  },
  {
    name: 'داکت و ترانک',
    image: '/images/categories/duct-min.png',
    url: '/cat/passive-equipment/trunk/',
  },
  {
    name: 'سوییچ',
    image: '/images/categories/network-switch-min.png',
    url: '/cat/active-equipment/network-switch/',
  },
  {
    name: 'روتر',
    image: '/images/categories/routers-min.png',
    url: '/cat/active-equipment/router/',
  },
  {
    name: 'رادیو وایرلس',
    image: '/images/categories/radio-wireless-min.png',
    url: '/cat/active-equipment/wireless-radio/',
  },
  {
    name: 'اکسس پوینت',
    image: '/images/categories/access-point-min.png',
    url: '/cat/active-equipment/access-point/',
  },
  {
    name: 'مودم همراه',
    image: '/images/categories/portable-modem-min.png',
    url: '/cat/active-equipment/modem/sim-card/',
  },
  {
    name: 'مودم ADSL VDSL',
    image: '/images/categories/adsl-min.png',
    url: '/cat/active-equipment/modem/adsl-modem/',
  },
];
export const modemCategories = [
  {
    name: 'همراه',
    image: '/images/modem-categories/simkart-modem.png',
    url: '/cat/active-equipment/modem/portable-modem',
  },
  {
    name: '3G 4G',
    image: '/images/modem-categories/vdsl-modem.png',
    url: '/cat/active-equipment/modem/vdsl-modem/',
  },
  {
    name: ' ADSL VDSL',
    image: '/images/modem-categories/adsl-modem.png',
    url: '/cat/active-equipment/modem/gaming-modem',
  },

  {
    name: 'فیبرنوری',
    image: '/images/modem-categories/fiber-modem.png',
    url: '/cat/active-equipment/modem/fiber-optic-modem',
  },
];

export const priceLists = [
  {
    name: 'روتر',
    image: '/images/categories/hub.png',
    url: '/page/router-price-list',
  },
  {
    name: 'مودم ',
    image: '/images/categories/modem-adsl.png',
    url: '/page/modem-price-list',
  },
  {
    name: 'کابل شبکه',
    image: '/images/categories/portable-modem.png',
    url: '/page/price-list-cable',
  },
  {
    name: 'سوئیچ سیسکو',
    image: '/images/categories/radio-wireless.png',
    url: '/page/switch-cisco-price-list',
  },
  {
    name: 'پچ پنل شبکه',
    image: '/images/categories/router-1.png',
    url: '/page/patch-panel-price-list',
  },
  {
    name: 'پچ کورد شبکه',
    image: '/images/categories/connection.png',
    url: '/page/patch-cord-price-list',
  },
];

export const popularBrands = [
  {
    image: { full_path: '/images/popular-brands/mikrotik-logo.jpg' },
    url: '/brand/mikrotik/',
  },
  {
    image: { full_path: '/images/popular-brands/dlink-logo.jpg' },
    url: '/brand/dlink/',
  },
  {
    image: {
      full_path: '/images/popular-brands/legrand-logo.jpg',
      alt: 'legrand',
    },
    url: '/brand/legrand/',
  },
  {
    image: {
      full_path: '/images/popular-brands/tplink-logo.jpg',
      alt: 'legrand',
    },
    url: '/brand/tp-link/',
  },
  {
    image: { full_path: '/images/popular-brands/cisco-logo.jpg' },
    url: '/brand/cisco/',
  },
  {
    image: { full_path: '/images/popular-brands/hpa-logo.jpg' },
    url: '/brand/hpa/',
  },
  {
    image: { full_path: '/images/popular-brands/nexans-logo.jpg' },
    url: '/brand/nexans/',
  },
  {
    image: { full_path: '/images/popular-brands/huawei-logo.jpg' },
    url: '/brand/huawei/',
  },

  {
    image: { full_path: '/images/popular-brands/ubiquiti-logo.jpg' },
    url: '/brand/ubiquiti/',
  },
];
